/* eslint-disable no-console */
export function setSite(site) {
    console.log('setSite:', site);
    return {
        type: 'SET_SITE',
        payload: site
    };
}